module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074ad_logo_200x200.4d653ce6.png";